import { Fragment } from "react";
import SearchOrCreateSelectInput from "../../core/inputs/SearchOrCreateSelectInput";
import { formatLocalTime } from "../../core/utils/utils";

function getInvoiceObjectLabel(invoice, preferredTimezone) {
    return <Fragment>
        <span><strong>{`${invoice.custom_id || invoice.id} (${invoice.status_label})`}</strong><br></br></span>
        <span className="select-label-secondary-level"><em>{invoice.service_name}</em><br></br></span>
        {invoice.date_issued && <span className="select-label-secondary-level">{formatLocalTime(invoice.date_issued, preferredTimezone, false, false, false, true).localDateString}</span>}
    </Fragment>
}

function invoiceToInvoiceOption(invoice, preferredTimezone) {
    return { value: invoice.id, label: getInvoiceObjectLabel(invoice, preferredTimezone), object: invoice }
}

function InvoiceSearchOrCreateSelect(props) {
    const { preferredTimezone } = props

    return <SearchOrCreateSelectInput
        objectName="Invoice"
        getObjectLabel={(invoice) => getInvoiceObjectLabel(invoice, preferredTimezone)}
        listEndpoint={DjangoUrls["invoices:api-invoices-search"](window.MARKETPLACE_ENTITY_SLUG)}
        listEndpointKwargs={[["ordering", "status,-date_issued"]]}
        getDetailsEndpoint={(invoice) => DjangoUrls["invoices:api-invoices-detail"](window.MARKETPLACE_ENTITY_SLUG, invoice.id)}
        {...props}
    />
}

export { invoiceToInvoiceOption };
export default InvoiceSearchOrCreateSelect
